export const OK = 'OK';